import PropTypes from 'prop-types';
import React from 'react';

const SummaryBody = ({buttons, POS, truBlue}) => {
  return (
    <div className='report-body'>
      <div className='row buttons-container'>
        { buttons.map((data, i) => (!data.posOnly || data.posOnly && POS) && (!data.truBlueOnly || data.truBlueOnly && truBlue)  ?
          <div key={i} className='col-sm-2'>
            <button onClick={() => window.location = data.link} className='report-button'>
              {data.label}
            </button>
          </div> : null)}
      </div>
    </div>);
};

SummaryBody.propTypes = {
  buttons: PropTypes.array,
  POS: PropTypes.bool,
  truBlue: PropTypes.bool,
};

export default SummaryBody;
